import { Reveal, ChapterLabel } from "@/components/Reveal";
import { IMAGES } from "@/content/images";
import { useLang } from "@/i18n";

const About = () => {
  const { lang, t } = useLang();
  const d = t.about;

  return (
    <section id="about" data-testid="about-section" className="bg-sand/45 px-6 py-28 md:px-12 md:py-44">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-14 md:grid-cols-12 md:gap-12">
        <div className="md:col-span-4">
          <ChapterLabel index="02" title={t.nav.about} />
          <Reveal delay={0.08} className="mt-10 max-w-md md:mt-14">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={IMAGES.about}
                alt={lang === "es" ? "Dos personas practicando yoga en la playa al atardecer" : "Two people practicing yoga on a beach at sunset"}
                className="h-full w-full object-cover object-center"
              />
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-7 md:col-start-6">
          <Reveal delay={0.08}>
            <div className="space-y-7 text-lg leading-relaxed text-charcoal/75 md:text-xl">
              {d.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
